import React, { useState } from "react";
import paymentpaypal from "../../../assets/images/payment-paypal.png";
import paymentcard from "../../../assets/images/payment-card.png";
import product1smpng from "../../../assets/images/product-1-sm.png";
import bgheader3png from "../../../assets/images/bg-header-3.png";
import { Link } from "react-router-dom";

function Checkout(props) {
  const [show, setShow] = useState(false);
  const [count, setCount] = useState(1);
  const [count1, setCount1] = useState(1);
  const Increment1 = () => {
    setCount1(count1 + 1);
  };
  const Decrement1 = () => {
    if (count1 > 1) {
      setCount1(count1 - 1);
    }
  };
  const Increment = () => {
    setCount(count + 1);
  };
  const Decrement = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handleShow = () => {
    setShow(true);
  };
  const handleHide = () => {
    setShow(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <header className="dx-header dx-box-5">
        <div className="bg-image bg-image-parallax">
          <img src={bgheader3png} className="jarallax-img" alt="" />
          <div style={{ backgroundColor: "rgba(27, 27, 27, .8)" }}></div>
        </div>
        <div className="container mnb-8">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <h1 className="h4 mb-10 text-white text-center">Checkout</h1>

              <ul className="dx-breadcrumbs text-center">
                <li>
                  <Link to="/index">Home</Link>
                </li>
                <li>
                  <Link to="/store">Store</Link>
                </li>
                <li>Checkout</li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-6">
              <div className="dx-box dx-box-decorated">
                <div className="dx-box-content">
                  <h2 className="h6 mnt-5 mnb-5">Product Information</h2>
                </div>
                <div className="dx-separator"></div>
                <div className="table-responsive">
                  <table className="dx-table dx-table-checkout">
                    <tbody>
                      <tr>
                        <th scope="row" className="dx-table-checkout-img">
                          <Link to="/product">
                            <img src={product1smpng} alt="" />
                          </Link>
                        </th>
                        <td className="dx-table-checkout-title">
                          <Link to="/product">
                            Sensific – Saying Beast Lesser for in Fruitful
                          </Link>
                        </td>
                        <td className="dx-table-checkout-price">
                          <div className="dx-table-checkout-price">$59</div>
                        </td>
                        <td className="dx-table-checkout-quantity">
                          <form className="dx-form dx-form-group-inputs dx-form-quantity">
                            <Link
                              className="dx-form-quantity-minus"
                              onClick={Decrement}
                            >
                              -
                            </Link>
                            <input
                              type="number"
                              name="quantity"
                              // defaultValue={count}
                              value={count}
                              min="1"
                              max="10"
                              className="form-control form-control-style-2 dx-form-quantity-input"
                            />
                            <Link
                              className="dx-form-quantity-plus"
                              onClick={Increment}
                            >
                              +
                            </Link>
                          </form>
                        </td>
                        <td className="dx-table-checkout-delete">
                          <Link>
                            <span className="icon pe-7s-close"></span>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" className="dx-table-checkout-img">
                          <Link to="/product">
                            <img src={product1smpng} alt="" />
                          </Link>
                        </th>
                        <td className="dx-table-checkout-title">
                          <Link to="/product">
                            Minist – Subdue Above for Signs Dry is Have Great
                          </Link>
                        </td>
                        <td className="dx-table-checkout-price">
                          <div className="dx-table-checkout-price">$39</div>
                        </td>
                        <td className="dx-table-checkout-quantity">
                          <form className="dx-form dx-form-group-inputs dx-form-quantity">
                            <Link
                              className="dx-form-quantity-minus"
                              onClick={Decrement1}
                            >
                              -
                            </Link>
                            <input
                              type="number"
                              name="quantity"
                              // defaultValue={count1}
                              value={count1}
                              min="1"
                              max="10"
                              className="form-control form-control-style-2 dx-form-quantity-input"
                            />
                            <Link
                              className="dx-form-quantity-plus"
                              onClick={Increment1}
                            >
                              +
                            </Link>
                          </form>
                        </td>
                        <td className="dx-table-checkout-delete">
                          <Link>
                            <span className="icon pe-7s-close"></span>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="dx-separator"></div>
                <div className="dx-box-content">
                  <form className="dx-form mnt-10">
                    <label htmlFor="code" className="mnt-6">
                      Discount Code
                    </label>
                    <div className="dx-form-group-inputs">
                      <input
                        type="text"
                        name=""
                        value=""
                        className="form-control form-control-style-2"
                        placeholder="Enter your Code"
                        id="code"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-grey-1">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
                <div className="dx-separator"></div>
                <div className="dx-box-content text-right">
                  <p className="text-dark-1 mnt-8 mnb-8">
                    Total Payment: <strong className="fs-18">$98</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="dx-box dx-box-decorated">
                <div className="dx-box-content">
                  <h2 className="h6 mnt-5 mnb-5">Payments Details</h2>
                </div>
                <div className="dx-separator"></div>
                <div className="dx-box-content">
                  <p className="mnt-6 mb-3 text-dark-1">
                    Choose Payment Method
                  </p>
                  <ul
                    className="nav dx-tab dx-tab-payment mnt-10 row vertical-gap sm-gap"
                    role="tablist"
                  >
                    <li className="nav-item col-sm-6">
                      <Link
                        className="nav-link active dx-tab-payment-method"
                        id="card-tab"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="card"
                        aria-selected="true"
                        onClick={handleHide}
                      >
                        <img src={paymentcard} alt="" />
                        <span className="dx-tab-payment-method-text">
                          Credit Card
                        </span>
                      </Link>
                    </li>
                    <li className="nav-item col-sm-6">
                      <Link
                        className="nav-link dx-tab-payment-method"
                        id="paypal-tab"
                        data-toggle="tab"
                        role="tab"
                        to="/checkout"
                        aria-controls="paypal"
                        aria-selected="false"
                        onClick={handleShow}
                      >
                        <img src={paymentpaypal} alt="" />
                      </Link>
                    </li>
                  </ul>
                </div>
                <div
                  className="tab-pane fade show active dx-tab-pane"
                  id="card"
                  role="tabpanel"
                  aria-labelledby="card-tab"
                >
                  <div className="dx-separator"></div>
                  <form action="#" className="dx-form">
                    {!show && (
                      <>
                        <div className="dx-box-content">
                          <div className="dx-form-group">
                            <label htmlFor="name-card" className="mnt-7">
                              Name on Card
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-style-2"
                              id="name-card"
                              placeholder="Enter Full Name"
                            />
                          </div>
                          <div className="dx-form-group">
                            <label htmlFor="card-number" className="mnt-7">
                              Card Number
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-style-2 dx-card-number"
                              name="card-number"
                              id="card-number"
                              placeholder="1234 5678 9012 3456"
                            />
                          </div>
                          <div className="dx-form-group">
                            <div className="row vertical-gap">
                              <div className="col-sm-8">
                                <label htmlFor="date" className="mnt-7">
                                  Expiration Date
                                </label>
                                <div className="dx-form-group-inputs">
                                  <select
                                    className="custom-select form-control form-control-style-2"
                                    id="date"
                                  >
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                  </select>
                                  <select className="custom-select form-control form-control-style-2 w-auto">
                                    <option value="1">2024</option>
                                    <option value="2">2023</option>
                                    <option value="3">2022</option>
                                    <option value="4">2020</option>
                                    <option value="5">2019</option>
                                    <option value="6">2018</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-sm-4">
                                <label htmlFor="password" className="mnt-7">
                                  CVV Number
                                </label>
                                <input
                                  type="password"
                                  className="form-control form-control-style-2 dx-form-quantity-input"
                                  min="1"
                                  max="999"
                                  id="password"
                                  placeholder="XXX"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="dx-separator"></div>
                        <div className="dx-box-content">
                          <div className="dx-form-group">
                            <label htmlFor="email" className="mnt-7">
                              Email
                            </label>
                            <input
                              type="email"
                              aria-describedby="emailHelp"
                              className="form-control form-control-style-2"
                              id="email"
                              placeholder="Enter your Email"
                            />
                          </div>
                          <div className="dx-form-group">
                            <label htmlFor="first-name" className="mnt-7">
                              First Name
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-style-2"
                              id="first-name"
                              placeholder="Enter your First Name"
                            />
                          </div>
                          <div className="dx-form-group">
                            <label htmlFor="last-name" className="mnt-7">
                              Last Name
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-style-2"
                              id="last-name"
                              placeholder="Enter your Last Name"
                            />
                          </div>
                        </div>
                      </>
                    )}
                    <div className="dx-separator"></div>
                    <div className="dx-box-content">
                      <button
                        className="dx-btn dx-btn-xl dx-btn-block"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        Purchase $98
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  className="tab-pane fade dx-tab-pane"
                  id="paypal"
                  role="tabpanel"
                  aria-labelledby="paypal-tab"
                >
                  <div className="dx-separator"></div>
                  <div className="dx-box-content">
                    <button
                      className="dx-btn dx-btn-xl dx-btn-block"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Purchase $98
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Checkout;
